<template>

<div>
  <LDBsTable
    url="component"
    defaultSort="purchaseDate"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="batch">{{ $t('batch') }}</label>
      <input
        type="text"
        id="batch"
        name="batch"
        class="form-control"
        :placeholder="$t('ph_batch')"
        v-model="query.batch"
        @input="upper('batch')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="itemType">{{ $t('itemType') }}</label>
      <input
        type="text"
        id="itemType"
        name="itemType"
        class="form-control"
        :placeholder="$t('ph_itemType')"
        v-model="query.itemType"
        @input="upper('itemType')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="provider">{{ $t('provider') }}</label>
      <input
        type="text"
        id="provider"
        name="provider"
        class="form-control"
        :placeholder="$t('ph_provider')"
        v-model="query.provider"
        @input="upper('provider')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="nf">{{ $t('nf') }}</label>
      <input
        type="text"
        id="nf"
        name="nf"
        class="form-control"
        :placeholder="$t('ph_nf')"
        v-model="query.nf"
        @input="upper('nf')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="purchase_date">{{ $t('purchase_date') }}</label>
      <input
        type="date"
        id="purchase_date"
        name="purchase_date"
        class="form-control"
        v-model="query.purchaseDate"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="warranty_date">{{ $t('warranty_date') }}</label>
      <input
        type="date"
        id="warranty_date"
        name="warranty_date"
        class="form-control"
        v-model="query.warrantyDate"
      />
    </div>
  </LDBsTable>
</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import moment from 'moment'

export default {
  name: 'BankAccountList',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('batch'),
          field: 'batch',
          sortable: true
        },
        {
          title: this.$t('itemType'),
          field: 'itemType',
          sortable: true
        },
        {
          title: this.$t('provider'),
          field: 'provider',
          sortable: true
        },
        {
          title: this.$t('nf'),
          field: 'nf',
          sortable: true
        },
        {
          title: this.$t('totalValueNF'),
          field: 'totalValueNF',
          formatter: value => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('amountItems'),
          field: 'amountItems',
          sortable: true
        },
        {
          title: this.$t('purchase_date'),
          field: 'purchaseDate',
          formatter: value => {
            return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
          },
          sortable: true
        },
        {
          title: this.$t('purchase_value'),
          field: 'purchaseValue',
          formatter: value => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('warranty_date'),
          field: 'warrantyDate',
          formatter: value => {
            return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `
              <a
                href="#/main/component/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'componentes' }
      },
      query: {
        id          : undefined,
        batch       : '',
        itemType    : undefined,
        provider    : '',
        nf          : '',
        purchaseDate: '',
        warrantyDate: ''
      }
    }
  },

  methods: {
    clear() {
      this.query.id           = undefined
      this.query.batch        = ''
      this.query.itemType     = undefined
      this.query.provider     = ''
      this.query.nf           = ''
      this.query.purchaseDate = ''
      this.query.warrantyDate = ''
    },

    upper(attribute) {
      this.query[attribute] = this.query[attribute].toUpperCase()
    }
  }
}
</script>
